import React from "react";
import EmptyListIcon from "assets/vectors/infoModal/Universal_Payment.svg";
import constants from "constants/constants";
import { app_route_ids, app_route_keys } from "constants/urlPaths";
import { MinimumBalanceToggle } from "../modules/WalletSettings/modules/MinimumBalanceToggle/MinimumBalanceToggle";
import { PayoutAddEditDetailsButton } from "../modules/WalletSettings/modules/PayoutAddEditDetailsButton/PayoutAddEditDetailsButton";
import { PayoutAutomationToggle } from "../modules/WalletSettings/modules/PayoutAutomationToggle/PayoutAutomationToggle";
import { ReactComponent as RevenueIcon } from "assets/images/affiliates/bookings.svg";
import GavelRoundedIcon from "@material-ui/icons/GavelRounded";

export const allTransactionPathName =
  app_route_ids[app_route_keys.WALLET_ALL_TRANSACTION];
export const settlementPathName =
  app_route_ids[app_route_keys.WALLET_SETTLEMENT];

export const WALLETS_RA_PROPS = (pathName) => {
  return {
    basePath: pathName,
    history: {
      location: {
        pathname: pathName,
        search: "",
        hash: "",
      },
    },
    location: {
      pathname: pathName,
      search: "",
      hash: "",
    },
    match: {
      path: pathName,
      url: pathName,
      isExact: true,
      params: {},
    },

    resource: pathName,
    hasList: true,
    hasEdit: false,
    hasShow: false,
    hasCreate: false,
    syncWithLocation: false,
    perPage: 50,
  };
};

export const WALLET_BALANCE_NIL = 0;

export const walletSectionKey = "wallet";
export const WALLET_BALANCE_KEY = "wallet_balance";

export const walletKeys = {
  walletAmount: "wallet_amount",
  walletBalance: "wallet_balance",
  availableWalletBalance: "available_wallet_balance",
};

export const walletStoreKeys = {
  isWalletActive: "isWalletActive",
  isPayViaWallet: "isPayViaWallet",
  topupModalOpen: "topupModalOpen",
  withdrawalModalOpen: "withdrawalModalOpen",
  automatedPayoutToggle: "automatedPayoutToggle",
  automatedPayoutModalOpen: "automatedPayoutModalOpen",
  automatedTopupToggle: "automatedTopupToggle",
  automatedTopupModalOpen: "automatedTopupModalOpen",
  settlementViewDetailsModalOpen: "settlementViewDetailsModalOpen",
  minBalanceToggle: "minBalanceToggle",
  minBalanceValue: "minBalanceValue",
};

export const FILTER_MIN_LENGTH_VALIDATION = {
  TRANSACTION_ID: 4,
  DESCRIPTION: 4,
};

export const AMOUNT_FIELD_PLACEHOLDER = "500";
export const MINIMUM_TOPUP_AMOUNT = 99;
export const MINIMUM_WITHDRAWAL_AMOUNT = 49;
export const DAILY_CUSTOM_CYCLE_DAYS = 1;

export const styles_header = {
  tabTitle:
    "tw-text-[#666666] tw-text-[14px] tw-leading-[18px] tw-mr-[26px] tw-cursor-pointer tw-pb-[12px] hover:tw-no-underline max-[780px]:tw-text-[12px] max-[780px]:tw-mr-[12px] max-[780px]:tw-pb-[8px]",
  tabTileActive:
    "tw-text-[#6c5dd3] tw-border-b-[2px] tw-border-solid tw-border-[#6c5dd3] tw-border-x-0 tw-border-t-0 tw-mb-[-2px]",
  button:
    "!tw-font-medium !tw-text-[16px] !tw-border-[1.5px] !tw-border-solid !tw-border-[#493AB1] !tw-rounded-[5px] !tw-px-[18px] !tw-py-[10px]",
};

export const walletTabs = {
  ALLTRANSACTIONS: "ALLTRANSACTIONS",
  SETTLEMENT: "SETTLEMENT",
};

export const WALLET_DIRECTION_ENUM = {
  CREDIT: 1, //what goes out(amount spent)
  DEBIT: 2, //what comes in(amount added)
};

export const WALLET_DIRECTION = {
  [WALLET_DIRECTION_ENUM.DEBIT]: {
    operator: "-",
    className: "tw-text-[#E62222]",
  },
  [WALLET_DIRECTION_ENUM.CREDIT]: {
    operator: "+",
    className: "tw-text-[#00994A]",
  },
};

export const WALLET_CATEGORIES_ENUM = {
  RECEIVED: 1,
  WITHDRAW: 2,
  TOPUP: 3,
  AD_SPENT: 4,
  PLAN_PAYMENT: 5,
  REFUND: 6,
  CREDITS_PAYMENT: 7,
  AFFILIATE_COMMISSION_PAYMENT: 8,
  WHATSAPP_CREDIT_PURCHASE: 9,
  EMAIL_CREDIT_PURCHASE: 10,
  MOBILE_APP_PURCHASE: 11,
  DISPUTE: 12,
  DISPUTE_FEE: 13,
};

export const WALLET_CATEGORIES_MAP = {
  [WALLET_CATEGORIES_ENUM.RECEIVED]: "Payment settlement",
  [WALLET_CATEGORIES_ENUM.WITHDRAW]: "Withdrawal",
  [WALLET_CATEGORIES_ENUM.TOPUP]: "Top-Up",
  [WALLET_CATEGORIES_ENUM.AD_SPENT]: "Ad Spent",
  [WALLET_CATEGORIES_ENUM.PLAN_PAYMENT]: "Exly plan purchase",
  [WALLET_CATEGORIES_ENUM.REFUND]: "Refund",
  [WALLET_CATEGORIES_ENUM.CREDITS_PAYMENT]: "Exly services purchase",
  [WALLET_CATEGORIES_ENUM.AFFILIATE_COMMISSION_PAYMENT]:
    "Affiliate Commission Payment",
  [WALLET_CATEGORIES_ENUM.WHATSAPP_CREDIT_PURCHASE]: "Whatsapp Credit Purchase",
  [WALLET_CATEGORIES_ENUM.EMAIL_CREDIT_PURCHASE]: "Email Credit Purchase",
  [WALLET_CATEGORIES_ENUM.MOBILE_APP_PURCHASE]: "Mobile app purchase",
  [WALLET_CATEGORIES_ENUM.DISPUTE]: "Dispute",
  [WALLET_CATEGORIES_ENUM.DISPUTE_FEE]: "Dispute Reopening Fees",
};

export const WALLET_STATUS = {
  [WALLET_CATEGORIES_ENUM.RECEIVED]: {
    id: 1,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.RECEIVED],
    className:
      "min-[768px]:tw-bg-[#EBFFD1] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px]",
    icon: "assets/images/wallets/shopping_bag_icon.png",
  },
  [WALLET_CATEGORIES_ENUM.WITHDRAW]: {
    id: 2,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.WITHDRAW],
    className:
      "min-[768px]:tw-bg-[#FFF5D0] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    icon: "assets/images/wallets/withdrawal_icon.png",
  },
  [WALLET_CATEGORIES_ENUM.TOPUP]: {
    id: 3,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.TOPUP],
    className:
      "min-[768px]:tw-bg-[#C6EEF9] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    icon: "assets/images/wallets/top_up_icon.png",
  },
  [WALLET_CATEGORIES_ENUM.AD_SPENT]: {
    id: 4,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.AD_SPENT],
    className:
      "min-[768px]:tw-bg-[#FCDCF6] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    icon: "assets/images/wallets/chart_icon.png",
  },
  [WALLET_CATEGORIES_ENUM.PLAN_PAYMENT]: {
    id: 5,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.PLAN_PAYMENT],
    className:
      "min-[768px]:tw-bg-[#DCD7FF] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    icon: "assets/images/wallets/plan_purchased_icon.png",
  },
  [WALLET_CATEGORIES_ENUM.REFUND]: {
    id: 6,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.REFUND],
    className:
      "min-[768px]:tw-bg-[#D0DCFF] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    icon: "assets/images/wallets/refund_icon.png",
  },
  [WALLET_CATEGORIES_ENUM.CREDITS_PAYMENT]: {
    id: 7,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.CREDITS_PAYMENT],
    className:
      "min-[768px]:tw-bg-[#DCD7FF] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    icon: "assets/images/wallets/cart_icon.png",
  },
  [WALLET_CATEGORIES_ENUM.AFFILIATE_COMMISSION_PAYMENT]: {
    id: 8,
    title:
      WALLET_CATEGORIES_MAP[
        WALLET_CATEGORIES_ENUM.AFFILIATE_COMMISSION_PAYMENT
      ],
    className:
      "min-[768px]:tw-bg-[#3B82F680] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    Icon: RevenueIcon,
    iconClassName: "!tw-fill-[#0052CC]",
    iconContainerClassName: "max-[767px]:tw-bg-[#3B82F680]",
  },
  [WALLET_CATEGORIES_ENUM.WHATSAPP_CREDIT_PURCHASE]: {
    id: 9,
    title:
      WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.WHATSAPP_CREDIT_PURCHASE],
    className:
      "min-[768px]:tw-bg-[#D7FFD0] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    icon: "assets/images/wallets/message_credits_icon.png",
  },
  [WALLET_CATEGORIES_ENUM.EMAIL_CREDIT_PURCHASE]: {
    id: 10,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.EMAIL_CREDIT_PURCHASE],
    className:
      "min-[768px]:tw-bg-[#FFE5D0] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    icon: "assets/images/wallets/email_sent_icon.png",
  },
  [WALLET_CATEGORIES_ENUM.MOBILE_APP_PURCHASE]: {
    id: 11,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.MOBILE_APP_PURCHASE],
    className:
      "min-[768px]:tw-bg-[#FFE5D0] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    icon: "assets/images/wallets/mobile_icon.png",
  },
  [WALLET_CATEGORIES_ENUM.DISPUTE]: {
    id: 12,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.DISPUTE],
    className:
      "min-[768px]:tw-bg-[#FFE5D0] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    Icon: GavelRoundedIcon,
    iconClassName: "!tw-fill-[#96485A]",
    iconContainerClassName: "max-[767px]:tw-bg-[#FFE5D0]",
  },
  [WALLET_CATEGORIES_ENUM.DISPUTE_FEE]: {
    id: 13,
    title: WALLET_CATEGORIES_MAP[WALLET_CATEGORIES_ENUM.DISPUTE_FEE],
    className:
      "min-[768px]:tw-bg-[#C6EEF9] min-[768px]:tw-w-max min-[768px]:tw-p-[1px_15px_1px_10px] min-[768px]:tw-rounded-[4px]",
    icon: "assets/images/wallets/top_up_icon.png",
  },
};

export const ALL_TRANSACTIONS_FIELD_DATA = {
  date_and_time: "created_at",
  transaction_id: "reference_id",
  category: "category",
  description: "description",
  amount: "amount",
  min_amount: "min_amount",
  max_amount: "max_amount",
  balance_after_transaction: "closing_balance",
  direction: "direction",
};
export const ALL_TRANSACTIONS_FORM_DATA = {
  date_and_time: "Date & Time",
  date: "Date",
  transaction_id: "Transaction ID",
  category: "Category",
  description: "Description / Source",
  amount: "Amount",
  min_amount: "Minimum Amount",
  max_amount: "Maximum Amount",
  balance_after_transaction: "Balance After Transaction",
  action: "Action",
};

export const SETTLEMENT_STATUS_LIST = {
  "Initiated by Exly": "Initiated",
  Pending: "Pending",
  "Missing/Invalid bank details": "Missing/Invalid bank details",
  Processed: "Completed",
  Failed: "Failed",
};

export const SETTLEMENT_STATUS_MAP = {
  INITIATED: "Initiated by Exly",
  PENDING: "Pending",
  MISSING_BANK: "Missing/Invalid bank details",
  PROCESSED: "Processed",
  FAILED: "Failed",
};

export const SETTLEMENT_STATUS = {
  [SETTLEMENT_STATUS_MAP.INITIATED]: {
    id: 1,
    title: SETTLEMENT_STATUS_LIST[SETTLEMENT_STATUS_MAP.INITIATED],
    className:
      "tw-w-fit tw-p-[3px_20px] tw-rounded-[4px] tw-bg-[#CBF5D2] max-[767px]:tw-p-[5px_10px] max-[767px]:tw-text-[12px] max-[767px]:tw-text-[#272522CC]",
    icon: null,
    viewDetailsModaltimelineStyles: {
      initiated: {
        connector: "tw-bg-[#009966]", // line connecting steps
        indicator: "tw-bg-[#009966]", // circle showing the step status
      },
      sentToPartner: {
        connector: "tw-bg-[#009966]",
        indicator: "tw-bg-[#009966]",
      },
      processing: {
        connector: "tw-bg-[#E5E5E5]",
        indicator: "tw-bg-[#E5E5E5]",
      },
      expectedArrival: {
        indicator: "tw-bg-[#e5e5e5]",
      },
    },
    expectedArrivalText: "Expected Arrival:",
  },
  [SETTLEMENT_STATUS_MAP.PENDING]: {
    id: 2,
    title: SETTLEMENT_STATUS_LIST[SETTLEMENT_STATUS_MAP.PENDING],
    className:
      "tw-w-fit tw-p-[3px_20px] tw-rounded-[4px] tw-bg-[#FFF5D0] max-[767px]:tw-p-[5px_10px] max-[767px]:tw-text-[12px] max-[767px]:tw-text-[#272522CC]",
    icon: null,
    viewDetailsModaltimelineStyles: {
      initiated: {
        connector: "tw-bg-[#E5E5E5]", // line connecting steps
        indicator: "tw-bg-[#E5E5E5]", // circle showing the step status
      },
      sentToPartner: {
        connector: "tw-bg-[#E5E5E5]",
        indicator: "tw-bg-[#E5E5E5]",
      },
      processing: {
        connector: "tw-bg-[#E5E5E5]",
        indicator: "tw-bg-[#E5E5E5]",
      },
      expectedArrival: {
        indicator: "tw-bg-[#E5E5E5]",
      },
    },
    expectedArrivalText: "Expected Arrival: ",
  },
  [SETTLEMENT_STATUS_MAP.MISSING_BANK]: {
    id: 3,
    title: SETTLEMENT_STATUS_LIST[SETTLEMENT_STATUS_MAP.FAILED],
    className:
      "tw-w-fit tw-p-[3px_20px] tw-rounded-[4px] tw-bg-[#FFD3D0] max-[767px]:tw-p-[5px_10px] max-[767px]:tw-text-[12px] max-[767px]:tw-text-[#272522CC]",
    icon: null,
    viewDetailsModaltimelineStyles: {
      initiated: {
        connector: "tw-bg-[#009966]", // line connecting steps
        indicator: "tw-bg-[#009966]", // circle showing the step status
      },
      sentToPartner: {
        connector: "tw-bg-[#009966]",
        indicator: "tw-bg-[#009966]",
      },
      processing: {
        connector: "tw-bg-[#009966]",
        indicator: "tw-bg-[#009966]",
      },
      expectedArrival: {
        indicator: "tw-bg-[#DB2020]",
      },
    },
    expectedArrivalText: `Payment failed: ${
      SETTLEMENT_STATUS_LIST[SETTLEMENT_STATUS_MAP.MISSING_BANK]
    }`,
  },
  [SETTLEMENT_STATUS_MAP.PROCESSED]: {
    id: 5,
    title: SETTLEMENT_STATUS_LIST[SETTLEMENT_STATUS_MAP.PROCESSED],
    className:
      "tw-w-fit tw-p-[3px_20px] tw-rounded-[4px] tw-bg-[#00b77999] max-[767px]:tw-p-[5px_10px] max-[767px]:tw-text-[12px] max-[767px]:tw-text-[#272522CC]",
    icon: null,
    viewDetailsModaltimelineStyles: {
      initiated: {
        connector: "tw-bg-[#009966]", // line connecting steps
        indicator: "tw-bg-[#009966]", // circle showing the step status
      },
      sentToPartner: {
        connector: "tw-bg-[#009966]",
        indicator: "tw-bg-[#009966]",
      },
      processing: {
        connector: "tw-bg-[#009966]",
        indicator: "tw-bg-[#009966]",
      },
      expectedArrival: {
        indicator: "tw-bg-[#009966]",
      },
    },
    expectedArrivalText: "Settled on: ",
  },
  [SETTLEMENT_STATUS_MAP.FAILED]: {
    id: 6,
    title: SETTLEMENT_STATUS_LIST[SETTLEMENT_STATUS_MAP.FAILED],
    className:
      "tw-w-fit tw-p-[3px_20px] tw-rounded-[4px] tw-bg-[#FFD3D0] max-[767px]:tw-p-[5px_10px] max-[767px]:tw-text-[12px] max-[767px]:tw-text-[#272522CC]",
    icon: null,
    viewDetailsModaltimelineStyles: {
      initiated: {
        connector: "tw-bg-[#009966]", // line connecting steps
        indicator: "tw-bg-[#009966]", // circle showing the step status
      },
      sentToPartner: {
        connector: "tw-bg-[#009966]",
        indicator: "tw-bg-[#009966]",
      },
      processing: {
        connector: "tw-bg-[#009966]",
        indicator: "tw-bg-[#009966]",
      },
      expectedArrival: {
        indicator: "tw-bg-[#DB2020]",
      },
    },
    expectedArrivalText: "Payment failed",
  },
};

export const SETTLEMENT_FIELD_DATA = {
  date_initiated: "execution_date",
  merchant_id: "merchant_id",
  transaction_id: "uuid",
  amount: "final_payout_amount",
  min_amount: "min_amount",
  max_amount: "max_amount",
  status: "display_status",
  estimated_arrival: "estimated_arrival",
};
export const SETTLEMENT_FORM_DATA = {
  date_initiated: "Date Initiated",
  transaction_id: "Transaction ID",
  amount: "Amount",
  min_amount: "Minimum Amount",
  max_amount: "Maximum Amount",
  status: "Status",
  action: "Action",
};

export const emptyStateProps = {
  page_title: "My Wallets",
  content_title: "No transactions yet",
  empty_list_icon: EmptyListIcon,
  alt: "no transactions",
  preview_image: constants.preview_all_transactions,
  children: "As soon as we have any transactions , it will show up here.",
};

// the regex validate if a number has 3 or more than 3 decimal places
export const validateAmountRegex = /^(\d*\.\d{3,})$/;
// the regex validate if a number has any decimal value
export const validateNumberRegex = /^(\d*\.\d{1,})$/;

export const WALLET_SETTING_KEYS = {
  AUTOMATED_PAYOUTS_CONFIG: "payouts_config",
  AUOMATED_PAYOUT_ADD_DETAILS: "payout_add_details",
  IS_PAYOUT_AUTOMATED: "is_payout_automated",
  AUOMATED_TOPUP_ADD_DETAILS: "topup_add_details",
  WALLET_CONFIG: "wallets_config",
  IS_AUTOMATED: "is_automated",
  MIN_BALANCE_LIMIT: "min_balance_limit",
};

export const WALLET_SETTING_TOGGLE_MAPPING = {
  [WALLET_SETTING_KEYS.AUTOMATED_PAYOUTS_CONFIG]:
    walletStoreKeys.automatedPayoutToggle,
  [WALLET_SETTING_KEYS.IS_PAYOUT_AUTOMATED]:
    walletStoreKeys.automatedTopupToggle,
};

export const WALLET_SETTING_CONFIG = [
  {
    title: "Automated Withdrawal",
    description: "Setup withdrawal automations for wallet balance",
    subSectionConfig: [
      {
        key: WALLET_SETTING_KEYS.AUTOMATED_PAYOUTS_CONFIG,
        title: "Enable Automated Withdrawal",
        description:
          "Enable this to automatically transfer your 'Available to withdraw' balance to your linked bank account.",
        customRightJSX: (
          <PayoutAutomationToggle
            subSectionKey={WALLET_SETTING_KEYS.AUTOMATED_PAYOUTS_CONFIG}
          />
        ),
      },
      {
        key: WALLET_SETTING_KEYS.AUOMATED_PAYOUT_ADD_DETAILS,
        title: "Withdrawal Automation Details",
        description:
          "Details such as the day, time, frequency and destination for Withdrawal automation.",
        customRightJSX: (
          <PayoutAddEditDetailsButton
            subSectionKey={WALLET_SETTING_KEYS.AUTOMATED_PAYOUTS_CONFIG}
          />
        ),
      },
    ],
  },
  // Uncomment the below segment when the backend is ready with auto debit services
  // {
  //   title: "Automated Wallet Top-Up",
  //   description:
  //     "Setup top-up automations for wallet balance",
  //   subSectionConfig: [
  //     {
  //       key: WALLET_SETTING_KEYS.IS_PAYOUT_AUTOMATED,
  //       title: "Enable automated top-up",
  //       description:
  //         "Enable this for continuous service by automatically adding funds when the balance runs low.",
  //       customRightJSX: <WalletSettingsToggle subSectionKey={WALLET_SETTING_KEYS.IS_PAYOUT_AUTOMATED} />,
  //     },
  //     {
  //       id: WALLET_SETTING_KEYS.AUOMATED_TOPUP_ADD_DETAILS,
  //       title: "Automated Top-up Details",
  //       description:
  //         "Details such as the day, time and frequency for automated top-ups.",
  //       customRightJSX: <AddDetailsButton actionTypeKey={walletStoreKeys.automatedTopupModalOpen} />
  //     },
  //   ],
  // },
  {
    title: "Minimum Wallet Limit",
    description: "Setup a minimum value for the wallet",
    subSectionConfig: [
      {
        key: WALLET_SETTING_KEYS.WALLET_CONFIG,
        title: "Set minimum balance limit",
        description:
          "Any withdrawals from the wallet will happen only from the amount that is left after minimum balance limit",
        customRightJSX: (
          <MinimumBalanceToggle
            subSectionKey={WALLET_SETTING_KEYS.WALLET_CONFIG}
          />
        ),
      },
    ],
  },
];

export const automatedPayoutKeys = {
  isAutomated: "is_automated",
  payoutType: "payout_type",
  payoutAmount: "payoutAmount",
  customSettlementAmount: "custom_settlement_amount",
  weeklyPayoutDay: "weekly_payout_day",
  monthlyPayoutDay: "monthly_payout_day",
  customCycleDays: "custom_cycle_days",
};

export const MAX_CUSTOM_DAYS_LIMIT = 364;

export const FREQUENCY_KEYS = {
  daily: 1,
  monthly: 2,
  custom: 3,
  weekly: 4,
};

export const FREQUENCY_OPTIONS = [
  {
    label: "T+1(Every week day)",
    value: FREQUENCY_KEYS.daily,
  },
  {
    label: "T+7(Once a week)",
    value: FREQUENCY_KEYS.weekly,
  },
  {
    label: "T+30(Once a Month)",
    value: FREQUENCY_KEYS.monthly,
  },
  {
    label: "Custom",
    value: FREQUENCY_KEYS.custom,
  },
];

export const PAYOUT_AMOUNT_KEYS = {
  full: 1,
  custom: 2,
};

export const PAYOUT_AMOUNT_OPTIONS = [
  {
    label: "Full amount withdrawal that is present in the wallet",
    value: PAYOUT_AMOUNT_KEYS.full,
  },
  {
    label: "Withdraw a custom amount",
    value: PAYOUT_AMOUNT_KEYS.custom,
  },
];

export const WEEK_DAYS_KEYS = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6,
};
export const WEEK_DAYS_KEYS_MAP = {
  [WEEK_DAYS_KEYS.monday]: "Monday",
  [WEEK_DAYS_KEYS.tuesday]: "Tuesday",
  [WEEK_DAYS_KEYS.wednesday]: "Wednesday",
  [WEEK_DAYS_KEYS.thursday]: "Thursday",
  [WEEK_DAYS_KEYS.friday]: "Friday",
  [WEEK_DAYS_KEYS.saturday]: "Saturday",
  [WEEK_DAYS_KEYS.sunday]: "Sunday",
};

export const WEEK_DAYS_OPTIONS = [
  {
    label: "Monday",
    value: WEEK_DAYS_KEYS.monday,
  },
  {
    label: "Tuesday",
    value: WEEK_DAYS_KEYS.tuesday,
  },
  {
    label: "Wednesday",
    value: WEEK_DAYS_KEYS.wednesday,
  },
  {
    label: "Thursday",
    value: WEEK_DAYS_KEYS.thursday,
  },
  {
    label: "Friday",
    value: WEEK_DAYS_KEYS.friday,
  },
  {
    label: "Saturday",
    value: WEEK_DAYS_KEYS.saturday,
  },
  {
    label: "Sunday",
    value: WEEK_DAYS_KEYS.sunday,
  },
];

export const DAYS_OF_THE_MONTH = {
  FIRST: 1,
  SECOND: 2,
  THIRD: 3,
  LAST_DAY: 99,
};

export const ROUNDOFF_UPTO = 2;

export const automatedTopupKeys = {
  thresholdAmount: "thresholdAmount",
  topupAmount: "topupAmount",
};
